import Icon from '../../../baseComponents/gui/icon/Icon';
import { INACTIVE } from '../../../../constants/components/pages/challenges/statuses';
import { image } from '../../../../utils/data/baseUrl';
import React from 'react';
import { useQuestFlags } from '../../../../hooks/shared/quests/useQuestFlags';
import classNames from 'classnames';

export default function TaskItemSign({ quest }) {
  const { isComplete, questState } = quest;
  const { isChallenge } = useQuestFlags({ quest });

  return (
    <>
      {isComplete && (
        <Icon
          name={!isChallenge ? 'tasks/task-arrow' : 'tasks/task-arrow-5'}
          className={classNames('task__item-arrow', { 'task__item-arrow_challenge': isChallenge })}
        />
      )}

      {questState === INACTIVE && <img src={image('challenges/lock.svg')} className={'task__item-lock'} />}
    </>
  );
}
